<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div
      class="header-nav container hidden-xs"
      style="display: flex; align-items: center; background-color: white"
    >
      <!-- 导航logo -->
      <div class="header-nav-logo" style="flex: 1">
        <img
          src="@/assets/img/Logo_DCT.jpg"
          style="max-width: 100%; height: auto"
        />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="{ active: index === navIndex }"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length">
            <dt
              v-for="(i, n) in item.children"
              :key="n"
              :class="{ 'header-nav-active': activeSecondLevelMenuIndex === n }"
              @click.stop="toggleSecondLevelMenu(n)"
            >
              <router-link :to="i.path">{{ i.name }}</router-link>
              <!-- Second level dropdown -->
              <dl
                v-if="i.children && i.children.length"
                v-show="activeSecondLevelMenuIndex === n"
              >
                <dd
                  v-for="(subItem, sIndex) in i.children"
                  :key="sIndex"
                  :class="{
                    'header-nav-active': activeThirdLevelMenuIndex === sIndex,
                  }"
                  @click.stop="toggleThirdLevelMenu(n, sIndex)"
                >
                  <router-link :to="subItem.path">{{
                    subItem.name
                  }}</router-link>
                  <!-- Third level dropdown -->
                  <dl
                    v-if="subItem.children && subItem.children.length"
                    v-show="activeThirdLevelMenuIndex === sIndex"
                  >
                    <dd
                      v-for="(thirdItem, tIndex) in subItem.children"
                      :key="tIndex"
                      :class="{
                        'header-nav-active':
                          activeFourthLevelMenuIndex === tIndex,
                      }"
                      @click.stop="toggleFourthLevelMenu(n, sIndex, tIndex)"
                    >
                      <router-link :to="thirdItem.path">{{
                        thirdItem.name
                      }}</router-link>
                      <dl
                        v-if="thirdItem.children && thirdItem.children.length"
                        v-show="activeFourthLevelMenuIndex === tIndex"
                      >
                        <dd
                          v-for="(fourthItem, fIndex) in thirdItem.children"
                          :key="fIndex"
                          :class="{
                            'header-nav-active':
                              activeFifthLevelMenuIndex === fIndex,
                          }"
                          @click.stop="
                            toggleFifthLevelMenu(n, sIndex, tIndex, fIndex)
                          "
                        >
                          <router-link :to="fourthItem.path">{{
                            fourthItem.name
                          }}</router-link>
                        </dd>
                      </dl>
                    </dd>
                  </dl>
                </dd>
              </dl>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/Logo_DCT.jpg" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center" style="flex: 1">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { getMenuList} from "@/api/api";
export default {
  name: "Header",
  data() {
    return {
      activeSecondLevelMenuIndex: null, // 追踪当前被激活的二级菜单索引
      activeThirdLevelMenuIndex: null, // Track the active third-level menu
      activeFourthLevelMenuIndex: null, // new line to track the fourth level
      activeFifthLevelMenuIndex: null, // new line to track the fourth level
      config: config,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList:[],
      // navList: [
      //   {
      //     name: "首页",
      //     path: "/",
      //     children: [],
      //   },
      //   {
      //     name: "关于我们",
      //     path: "/about-us",
      //     children: [],
      //   },
      //   {
      //     name: "产品",
      //     path: "/product",
      //     children: [
      //       {
      //         name: "EDWinXP",
      //         path: "/product/EDWinXPIntro",
      //         children: [
      //           //添加子链接的示例
      //           {
      //             name: "EDWinXP基本特性",
      //             path: "/product/EDWinXPIntro",
      //             children: [
      //               {
      //                 name: "原理图编辑器",
      //                 path: "/product/schematic",
      //                 children: [
      //                   {
      //                     name: "组件加载",
      //                     path: "/product/EDWinXP/EDWinXPIntro/schematic/loadingComponents",
      //                   },
      //                   {
      //                     name: "建立连接",
      //                     path: "/product/EDWinXP/EDWinXPIntro/schematic/establishConnection",
      //                   },
      //                   {
      //                     name: "自动配置",
      //                     path: "/product/EDWinXP/EDWinXPIntro/schematic/autoPlace",
      //                   },
      //                 ],
      //               },
      //               {
      //                 name: "布线编辑器",
      //                 path: "/product/EDWinXP/EDWinXPIntro/layout",
      //                 children: [
      //                   {
      //                     name: "埋孔",
      //                     path: "/product/EDWinXP/EDWinXPIntro/layout/buryVias",
      //                   },
      //                   {
      //                     name: "3D视图查看器",
      //                     path: "/product/EDWinXP/EDWinXPIntro/layout/3DViewer",
      //                   },
      //                   {
      //                     name: "自动布线",
      //                     path: "/product/EDWinXP/EDWinXPIntro/layout/autoRouter",
      //                   },
      //                   {
      //                     name: "特性阻抗计算器",
      //                     path: "/product/EDWinXP/EDWinXPIntro/layout/Characteristics-Impedance",
      //                   },
      //                 ],
      //               },
      //               {
      //                 name: "制造管理器",
      //                 path: "/product/EDWinXP/EDWinXPIntro/fabrication",
      //                 children: [
      //                   {
      //                     name: "生成Gerber输出",
      //                     path: "/product/EDWinXP/EDWinXPIntro/fabrication/gerber",
      //                   },
      //                   {
      //                     name: "数控钻孔机",
      //                     path: "/product/EDWinXP/EDWinXPIntro/fabrication/NC-drill",
      //                   },
      //                   {
      //                     name: "PCB组装输出 & 裸板测试",
      //                     path: "/product/EDWinXP/EDWinXPIntro/fabrication/PCBAssembly_BareBoard",
      //                   },
      //                   {
      //                     name: "导出",
      //                     path: "/product/EDWinXP/EDWinXPIntro/fabrication/Export",
      //                   },
      //                 ],
      //               },
      //               // {
      //               //   name: "库",
      //               //   path: "/product/EDWinXP/sublink1/subsublink2",
      //               // },
      //               {
      //                 name: "模拟器",
      //                 path: "/product/EDWinXP/EDWinXPIntro/Simulation",
      //               },
      //               {
      //                 name: "常规特性",
      //                 path: "/product/EDWinXP/EDWinXPIntro/General",
      //               },
      //             ],
      //           },
      //           {
      //             name: "EDWinXP2.10特性",
      //             path: "/product/EDWinXP2.10",
      //           },
      //           {
      //             name: "Enterprise License Manager",
      //             path: "/product/Enterprise_License_Manager",
      //           },
      //           {
      //             name: "DocOne & EDComX",
      //             path: "/product/DocOne&EDComX",
      //           },
      //           // {
      //           //   name: "EDWinNET",
      //           //   path: "/product/EDWinNET",
      //           // },
      //         ],
      //       },
      //       {
      //         name: "EDWin2.11",
      //         path: "/product/EDWin2.11",
      //       },
      //       {
      //         name: "EDWin3",
      //         path: "/product/EDWin3",
      //         //   children:[
      //         //     {
      //         //       name: "EDWin3帮助文档",
      //         //       path:"/product/EDWin3/Docs",

      //         //     }
      //         // ]
      //       },
      //     ],
      //   },
      //   {
      //     name: "下载",
      //     path: "/download",
      //     children: [
          
      //     ],
      //   },
      //   {
      //     name: "在线商店",
      //     path: "/onlineShop",
      //     children: [

      //     ],
      //   },
      //   {
      //     name: "资料",
      //     path: "/materials",
      //     children: [
      //       {
      //         name: "EDWinXP通用",
      //         path: "/materials/EDWinXP_Normal",
      //       },
      //       {
      //         name: "教程",
      //         path: "/materials/Tutorials",
      //       },
      //       {
      //         name: "培训",
      //         path: "/materials/training",
      //       },
      //       {
      //         name: "演示",
      //         path: "/materials/show",
      //       },
      //       {
      //         name: "视频教程",
      //         path: "/materials/videoTutorials",
      //       },
      //       {
      //         name: "VHDL程序",
      //         path: "/materials/VHDL_Program",
      //       },
      //       {
      //         name: "微处理器程序",
      //         path: "/materials/MicroProcessorProgram",
      //       },
      //     ],
      //   },
      //   {
      //     name: "服务支持",
      //     path: "/",
      //     children: [],
      //   },
      //   {
      //     name: "联系我们",
      //     path: "/contactus",
      //     children: [],
      //   },
      //   {
      //     name: "留言反馈",
      //     path: "/leaveMessage",
      //     children: [],
      //   },
      // ],
    };
  },
 created() {
    this.initMenu();
  },
  methods: {

    initMenu() {
      getMenuList().then((data) => {
        if (data.status === 200) {
          this.navList = this.transformMenuItems(data.data);
        }
      });
    },
    transformMenuItems(menuItems) {
    return menuItems.map(item => ({
      name: item.name,
      path: item.path,
      children: this.transformSubMenuItems(item.subMenu)
    }));
  },

transformSubMenuItems(subMenuItems) {
  // 如果没有子菜单，则返回空数组
  if (!subMenuItems || subMenuItems.length === 0) {
    return [];
  }
  // 否则，递归转换子菜单项
  return this.transformMenuItems(subMenuItems);
},
    navClick(index, name) {
      // sessionStorage.setItem("navIndex", index);
      // this.menuName = name;
      if (this.navIndex === index) {
        // reset all if the same menu item is clicked again
        this.resetMenus();
      } else {
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
      }
    },
    menuClick() {
      // if (this.menuClass == "glyphicon glyphicon-menu-down") {
      //   this.menuClass = "glyphicon glyphicon-menu-up";
      // } else {
      //   this.menuClass = "glyphicon glyphicon-menu-down";
      // }
    },
    toggleSecondLevelMenu(index) {
      // Toggle second-level menu
      this.activeSecondLevelMenuIndex =
        index === this.activeSecondLevelMenuIndex ? null : index;
      this.resetLowerMenus();
    },
    toggleThirdLevelMenu(n, sIndex) {
      // Only allow toggling if the correct second-level menu is active
      if (this.activeThirdLevelMenuIndex === sIndex) {
        this.activeThirdLevelMenuIndex = null;
      } else {
        this.activeThirdLevelMenuIndex = sIndex;
      }
      this.activeFourthLevelMenuIndex = null; // Reset fourth level when changing third level
    },
    toggleFourthLevelMenu(n, sIndex, tIndex) {
      this.activeFourthLevelMenuIndex =
        tIndex === this.activeFourthLevelMenuIndex ? null : tIndex;
    },
    toggleFifthLevelMenu(n, sIndex, tIndex, fIndex) {
      this.activeFifthLevelMenuIndex =
        this.activeFifthLevelMenuIndex === fIndex ? null : fIndex;
    },
    resetMenus() {
      this.activeSecondLevelMenuIndex = null;
      this.activeThirdLevelMenuIndex = null;
      this.activeFourthLevelMenuIndex = null;
      this.activeFifthLevelMenuIndex = null;
    },
    resetLowerMenus() {
      this.activeThirdLevelMenuIndex = null;
      this.activeFourthLevelMenuIndex = null;
      this.activeFifthLevelMenuIndex = null;
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  height: 90px;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 80px; */
  flex: 4;
  height: 95px;
  display: flex;
  /* float: left; */
  position: relative;
  margin-right: 70px; /* 根据需要调整与后续导航项之间的间距 */
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 150px;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 100px;
  /* float: right; */
  margin: 0;
  flex: 6; /* 占据右侧七份空间 */
  display: flex;
  justify-content: space-between; /* 导航项均匀分布 */
  align-items: center;
  width: 70%; /* 确保占满剩余空间 */
  list-style: none; /* 移除列表默认样式 */
  padding: 0; /* 移除默认padding */
  margin: 0; /* 对齐容器 */
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding: 5px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 260px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #fff;
  background: #fff;
  font-size: 18px;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #fff;
  position: relative;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
  color: #1e73be; /* Highlight color for active link */
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
  cursor: pointer;
  background: #fff;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #fff;
}
/* Hide third-level dropdown by default */
#header .header-nav .header-nav-wrapper > li > dl > dt > dl,
.header-nav-wrapper > li > dl > dt > dl > dd > dl,
.header-nav-wrapper > li > dl > dt > dl > dd > dl > dd > dl {
  display: none;
  position: absolute; /* Position absolutely to align with parent */
  left: 100%; /* Position to the right of the parent */
  top: 0; /* Align with the top of the parent */
  white-space: nowrap; /* Ensure the dropdown does not wrap */
  background: #fff; /* Match the background of the second-level dropdown */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Optional: adds a shadow for better visibility */
  z-index: 1001; /* Ensure it's above other elements */
}
/* Show third-level dropdown when its parent second-level 'dt' is hovered */
/* #header .header-nav .header-nav-wrapper > li > dl > dt:hover > dl {
  display: none;
} */
/* Add CSS for showing the dropdown when the item is active */
.header-nav-active dt > dl {
  display: block; /* Show the third-level dropdown */
}
/* Style for third-level dropdown links */
.header-nav-wrapper > li > dl > dt > dl > dd {
  padding: 10px; /* Provide padding for clickable area */
  border-bottom: 1px solid #eee; /* Optional: adds a separator between items */
}
/* Hover effect for third-level dropdown links */
.header-nav-wrapper > li > dl > dt > dl > dd:hover {
  background-color: #f8f8f8; /* Slight background change on hover */
}
.header-nav-wrapper > li > dl > dt > dl > dd > dl > dd {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.header-nav-wrapper > li > dl > dt > dl > dd > dl > dd:hover {
  background-color: #f8f8f8;
}
.header-nav-wrapper > li > dl > dt > dl > dd > dl > dd > dl > dd {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.header-nav-wrapper > li > dl > dt > dl > dd > dl > dd > dl > dd:hover {
  background-color: #f8f8f8;
}
/* Modify hover styles to prevent unwanted displays */
#header .header-nav .header-nav-wrapper > li:hover > dl > dt > a,
#header .header-nav .header-nav-wrapper > li > dl > dt:hover > a,
#header .header-nav .header-nav-wrapper > li > dl > dt > dl > dd:hover > a,
#header
  .header-nav
  .header-nav-wrapper
  > li
  > dl
  > dt
  > dl
  > dd
  > dl
  > dd:hover
  > a {
  text-decoration: none;
  color: #1e73be; /* Highlight color for active link */
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 30px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #fff;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 5px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue